import React, { useState } from 'react';
import { AvatarPicker } from '@teetsh/app/src/components/AvatarPicker';
import Card from '@teetsh/app/src/components/Card';
import { Avatar } from './Avatar';
import tw from 'twin.macro';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import { css } from '@emotion/react';

interface Dimensions {
  height: number;
  width: number;
}

interface Props {
  picture?: string;
  focus?: 'portrait';
  dimensions?: Dimensions;
  className?: string;
  onChange?: (v: string) => void;
  onUpload?: ({ file }: { file: File }) => Promise<any>;
  isUploading?: boolean;
  fill?: boolean;
  large?: boolean;
}

export function AvatarCard(props: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { picture, onChange, onUpload, className, isUploading, fill, large } =
    props;

  const dimensions = props.dimensions || {
    width: large ? 128 : 60,
    height: large ? 128 : 60,
  };

  return (
    <div data-testid="avatar-picture" style={dimensions} className={className}>
      {onChange && (
        <AvatarPicker
          isOpen={isOpen}
          isUploading={isUploading}
          onUpload={onUpload}
          onChange={v => {
            if (props.onChange) {
              if (v === 'user') {
                return props.onChange('');
              }
              return props.onChange(v || '');
            }
          }}
          onClose={() => setIsOpen(false)}
        />
      )}
      <Card
        onClick={() => setIsOpen(true)}
        interactive={!!onChange}
        css={[
          tw`relative rounded-xl p-0! flex justify-center items-center h-full`,
          picture !== 'user' && tw`bg-neutral-moderate`,
          picture === 'user' && tw`border-none! ring-0`,
          css`
            padding: 0;
          `,
        ]}
      >
        {onChange && !picture && (
          <div
            className="group"
            tw="absolute top-0 bottom-0 right-0 left-0 h-full w-full text-neutral-quiet hover:text-neutral-quiet"
          >
            <div tw="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Plus tw="h-12 w-12" />
            </div>
          </div>
        )}
        <Avatar
          isEditable={!!onChange}
          fill={fill}
          picture={picture}
          tw="rounded-xl"
          dimensions={dimensions}
        />
      </Card>
    </div>
  );
}
